module.exports = __webpack_public_path__ + "static/media/Supreeth-Rao.a4af254d.svg";